import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IUplift = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6172 6.47147L6.92532 12.1455L5.70703 10.9273L13.4922 3.14209L21.2774 10.9273L20.0591 12.1747L14.3672 6.48255V14.8198H12.6172V6.47147ZM12.6172 20.6532V17.1532H14.3672V20.6532H12.6172ZM12.6172 25.3198V22.9865H14.3672V25.3198H12.6172Z" fill="#282B34" />
          </svg>

        );
      }}
      {...props}
    />
  );
};

export default IUplift;
